import { differenceInDays } from 'date-fns';

export const isExpired = (expiredDate: Date) => {
  const MONTH = 30;

  const daysDifferential = differenceInDays(new Date(), expiredDate);
  if (daysDifferential <= 0 && Math.abs(daysDifferential) <= MONTH * 3) {
    return true;
  } else if (daysDifferential >= 0 && daysDifferential <= MONTH * 6) {
    return true;
  } else {
    return false;
  }
};
